import script from "./CustomerPhotos.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerPhotos.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerPhotos.vue?vue&type=style&index=0&id=d5db5fe4&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5db5fe4"]])

export default __exports__